import React from "react";
import _ from "lodash";
import { FormatMessage } from "react-globalize";

/**
 * Composes message with formatted summary of bulk entries add
 *
 * @param {Array<object>} [data.createdEntries] - Created entries
 * @param {Array<object>} [data.rejectedEntries] - Rejected entries
 * @returns {JSX.Element} - react element containing message and link to linesheet
 */
export const getCartAddSummaryMessage = (data: { createdEntries?: any[]; rejectedEntries?: any[] }) => {
    const { createdEntries, rejectedEntries } = data;
    const totalAdded = _.size(createdEntries);
    const totalRejected = _.size(rejectedEntries);
    const fullAmount = totalAdded + totalRejected;
    let amount: number;
    let message: string;
    if (totalRejected === fullAmount) {
        message = "|amount| product(s) could not be added because they are not available in the selected warehouse.";
        amount = totalRejected;
    } else {
        message =
            "|amount| of |fullAmount| product(s) could not be added because they are not available in the selected warehouse.";
        amount = totalRejected;
    }
    return (
        <span>
            <FormatMessage path={message} variables={{ amount, fullAmount }} />
        </span>
    );
};
